import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { StorageService } from "../services/storage.service";
import { appRoute } from "src/app/app-route.constants";

/**
 * Fallback routes (e.g. /marketing) are where SSO lands users who do NOT have
 * access to Rehab Connect, so there should never be an active session here.
 * If a session exists, the user must not remain on the fallback route — redirect
 * them into the app and let the existing guards/interceptor enforce validity.
 */
export const fallbackRouteGuard: CanActivateFn = () => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  const hasActiveSession =
    storageService.getUser() !== null && storageService.getAccessToken() !== null;

  if (hasActiveSession) {
    return router.createUrlTree([`/${appRoute.home}`]);
  }

  return true;
};
